type AppIdMap = {
  [key: string]: {
    productName: string;
  };
};

const appIdMap: AppIdMap = {
  'bid-aec-revit': {
    productName: 'Revit',
  },
};

export default appIdMap;
